// services/autorizaciones.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralResponse } from '../../models/autorizaciones/GeneralResponse';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { SendMessageRequest } from '../../models/wolkvox/SendMessageRequest';
import { SendMessageItem } from '../../models/wolkvox/SendMessageItem';

@Injectable({
    providedIn: 'root'
})
export class SendMessageService {

    private baseUrl = `${ENV.HOST}${URL_MAP.API.SENDMESSAGE_WOLKVOX}`;

    constructor(private http: HttpClient) { }

    sendMessage(
        request: SendMessageRequest) {

        return this.http.post<GeneralResponse<SendMessageItem[]>>(
            `${this.baseUrl}`,
            request
        );
    }
}